import React from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { FileText, AlertCircle, CheckCircle, Clock, Eye, Shield, Building2, Calculator, Home, UserPlus } from 'lucide-react';

import { toast } from 'sonner';

import MessagerieDashboard from '../../components/Messagerie/MessagerieDashboard';
import ExpertProfileEdit from '../../components/ProfileEdit/ExpertProfileEdit';
import MesConventions from '../../components/MesConventions';

import ModuleSignatureExpert from '../../components/ModuleSignatureExpert';
import GestionModeles from '../../components/GestionModeles';
import VideoManager from '../../components/GED/VideoManager';
import GEDDomium from '../../components/GED/GEDDomium';
import GEDUniverselle from '../../components/GED/GEDUniverselle';

import ExpertWalletDashboard from '../../components/ExpertWalletDashboard';

import FTPESubscriptionForMember from '../../components/FTPESubscriptionForMember';
import ChangePasswordForm from '../../components/ProfileEdit/ChangePasswordForm';
import CooperMembresManagement from '../../components/CooperMembresManagement';
import DOMIUMSubscriptionSimulator from '../../components/DOMIUMSubscriptionSimulator';
import { getToken } from '../../services/tokenService';

import ExpertDommagesTab from './ExpertDommagesTab';
import ExpertMembresConfies from '../../components/ExpertMembresConfies';

export default function ExpertTabs({ ctx }) {
  const { user, activeTab, setActiveTab, dommages, stats, expertProfile, setExpertProfile, setSelectedDommage, _filterStatus, _setFilterStatus, _searchQuery, _setSearchQuery, getAuthHeader, getStatutBadge, getTypeBadge, _filteredDommages } = ctx;
  return (
    <>
        {activeTab === 'wallet-credits' && (
          <ExpertWalletDashboard />
        )}

        {/* FTPE Membres */}
        {activeTab === 'ftpe-membres' && (
          <div className="space-y-6">
            <Card className="border-l-4 border-l-amber-500">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-amber-700">
                  <UserPlus className="h-6 w-6 text-amber-500" />
                  Souscription FTPE pour vos Membres
                </CardTitle>
                <CardDescription>
                  Inscrivez vos membres accompagnés à la FTPE Outremer
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl p-6 text-white mb-6">
                  <h3 className="text-xl font-bold mb-2">🏢 Adhésion FTPE Outremer</h3>
                  <p className="text-amber-100 mb-4">
                    En tant qu'Expert, vous pouvez inscrire les membres que vous accompagnez à la Fédération des TPE Outremer.
                  </p>
                  <FTPESubscriptionForMember onSuccess={() => {
                    toast.success('Adhésion FTPE créée avec succès pour le membre');
                  }} />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                  <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
                    <div className="text-2xl mb-2">👥</div>
                    <p className="text-sm font-medium text-amber-800">Représentation patronale</p>
                  </div>
                  <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
                    <div className="text-2xl mb-2">🛡️</div>
                    <p className="text-sm font-medium text-amber-800">Accès aux garanties</p>
                  </div>
                  <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
                    <div className="text-2xl mb-2">🤝</div>
                    <p className="text-sm font-medium text-amber-800">Réseau solidaire</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        )}

        {/* Mes Membres */}
        {activeTab === 'mes-membres' && (
          <CooperMembresManagement />
        )}

        {activeTab === 'membres-confies' && (
          <ExpertMembresConfies />
        )}

        {/* Estimateur Solidaire */}
        {activeTab === 'simulateur' && (
          <div className="space-y-6">
            <Card className="border-l-4 border-l-coppam-gold">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-orange-700">
                  <Calculator className="h-6 w-6 text-coppam-gold" />
                  Simulateur Garantie Solidaire BATICO
                </CardTitle>
                <CardDescription>
                  Outil d'estimation pour les Conseillers Stratégiques BTP
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="bg-gradient-to-r from-orange-600 to-amber-600 rounded-xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-2">🧮 Simulateur Garantie RCDS BATICO</h3>
                  <p className="text-orange-100 mb-4">
                    Calculez les cotisations et estimez les garanties pour vos évaluations.
                  </p>
                  <div className="flex flex-wrap gap-3">
                    <a href="/calculateur-batico" target="_blank" rel="noopener noreferrer">
                      <Button className="bg-white hover:bg-gray-100 text-orange-700 font-semibold">
                        <Calculator className="h-4 w-4 mr-2" />
                        Accéder au Simulateur
                      </Button>
                    </a>
                  </div>
                </div>
                <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                  <div className="p-4 bg-slate-50 rounded-lg">
                    <div className="text-2xl mb-2">📋</div>
                    <p className="text-sm text-slate-600">Évaluation précise</p>
                  </div>
                  <div className="p-4 bg-slate-50 rounded-lg">
                    <div className="text-2xl mb-2">🔍</div>
                    <p className="text-sm text-slate-600">Tarifs détaillés</p>
                  </div>
                  <div className="p-4 bg-slate-50 rounded-lg">
                    <div className="text-2xl mb-2">📊</div>
                    <p className="text-sm text-slate-600">Historique sauvegardé</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        )}

        {/* Simulateur DOS-DOMIUM */}
        {activeTab === 'simulateur-dos' && (
          <Card className="border-l-4 border-l-orange-500">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-coppam-blue">
                <Home className="h-6 w-6 text-orange-500" />
                Simulateur DOS-DOMIUM
              </CardTitle>
              <CardDescription>
                Dommages-Ouvrage Solidaire - Simulez et gérez les souscriptions pour vos clients
              </CardDescription>
            </CardHeader>
            <CardContent>
              <DOMIUMSubscriptionSimulator userRole="expert" />
            </CardContent>
          </Card>
        )}

        {/* V38.14 — Bloc CCMI-CAP BÂTI : raccourci vers le simulateur CAP BATI+ CMI */}
        {activeTab === 'simulateur-ccmi' && (
          <Card className="border-l-4 border-l-blue-500" data-testid="ccmi-cap-bati-block">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-coppam-blue">
                <Building2 className="h-6 w-6 text-blue-500" />
                CCMI-CAP BÂTI
              </CardTitle>
              <CardDescription>
                Sécurisation des Contrats de Construction de Maison Individuelle.
                Estimez la cotisation CAP BATI+ CMI et les contributions FOGEDOM/SCIC
                + Expertise préventive.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-3">
              <a
                href="/simulateurs/cap-bati-plus-cmi"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="ccmi-block-open-cap-bati-simulator"
              >
                <Button className="bg-orange-600 hover:bg-orange-700">
                  <Calculator className="h-4 w-4 mr-2" />
                  Ouvrir le simulateur CAP BATI+ CMI
                </Button>
              </a>
              <p className="text-xs text-slate-500">
                Calculs en temps réel : CAP BATI+ (coût HT × coef) · Option GFA (coût TTC × coef GFA)
                · FOGEDOM/SCIC 9,50 % · Expertise préventive 9,50 %.
              </p>
            </CardContent>
          </Card>
        )}

        {/* Dashboard Overview */}
        {activeTab === 'dashboard' && (
          <div className="space-y-6">
            {/* Header */}
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-slate-900">Tableau de Bord COOPER'S Advisor</h1>
              </div>
              <Badge className="bg-green-700 text-white text-sm px-4 py-2 shadow-md font-semibold">
                <CheckCircle className="mr-2 h-4 w-4" />
                Compte Validé
              </Badge>
            </div>

            {/* Message d'accueil */}
            <Card className="border-l-4 border-l-blue-600 bg-gradient-to-r from-blue-50 to-indigo-50">
              <CardContent className="pt-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <Shield className="h-6 w-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-xl font-bold text-slate-900 mb-3">
                      Bienvenue, Conseiller Stratégique et Facilitateur {expertProfile?.prenom} {expertProfile?.nom}
                    </h2>
                    <p className="text-slate-700 leading-relaxed mb-3">
                      Votre espace dédié vous permet d'évaluer et suivre les dommages en toute sécurité.
                    </p>
                    <p className="text-slate-700 leading-relaxed mb-3">
                      Votre rôle de Conseiller Stratégique et Facilitateur contribue directement à la fiabilité des évaluations et au bon fonctionnement du dispositif.
                    </p>
                    <p className="text-blue-800 font-medium">
                      Merci pour votre engagement aux côtés de <strong>COPPAM / FOGEDOM-SCIC</strong>.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Statistiques */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <Card className="border-l-4 border-l-blue-600">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-slate-600">Total Dommages</p>
                      <p className="text-3xl font-bold text-blue-600">{stats.total || 0}</p>
                    </div>
                    <FileText className="h-10 w-10 text-blue-600 opacity-20" />
                  </div>
                </CardContent>
              </Card>

              <Card className="border-l-4 border-l-purple-600">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-slate-600">En Expertise</p>
                      <p className="text-3xl font-bold text-purple-600">
                        {stats.par_statut?.expertise_en_cours || 0}
                      </p>
                    </div>
                    <AlertCircle className="h-10 w-10 text-purple-600 opacity-20" />
                  </div>
                </CardContent>
              </Card>

              <Card className="border-l-4 border-l-orange-600">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-slate-600">En Attente</p>
                      <p className="text-3xl font-bold text-orange-600">
                        {(stats.par_statut?.déclaré || 0) + (stats.par_statut?.en_attente_pièces || 0)}
                      </p>
                    </div>
                    <Clock className="h-10 w-10 text-orange-600 opacity-20" />
                  </div>
                </CardContent>
              </Card>

              <Card className="border-l-4 border-l-green-600">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-slate-600">Traités</p>
                      <p className="text-3xl font-bold text-green-600">
                        {(stats.par_statut?.traité || 0) + (stats.par_statut?.clos || 0)}
                      </p>
                    </div>
                    <CheckCircle className="h-10 w-10 text-green-600 opacity-20" />
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Dommages récents */}
            <Card>
              <CardHeader>
                <CardTitle>Dommages Récents</CardTitle>
                <CardDescription>Vos 5 derniers dommages assignés</CardDescription>
              </CardHeader>
              <CardContent>
                {dommages.slice(0, 5).length === 0 ? (
                  <div className="text-center py-12">
                    <FileText className="mx-auto h-12 w-12 text-slate-300 mb-4" />
                    <p className="text-slate-600">Aucun dommage assigné pour le moment</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {dommages.slice(0, 5).map(dommage => (
                      <div
                        key={dommage.id}
                        className="flex items-center justify-between p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
                        onClick={() => {
                          setSelectedDommage(dommage);
                          setActiveTab('dommages');
                        }}
                      >
                        <div className="flex-1">
                          <div className="flex items-center gap-3 mb-2">
                            <span className="font-mono text-sm font-semibold text-slate-900">
                              {dommage.numero_dommage}
                            </span>
                            {getStatutBadge(dommage.statut)}
                            {getTypeBadge(dommage.type_dommage)}
                          </div>
                          <p className="text-sm text-slate-700 font-medium">{dommage.raison_sociale}</p>
                          <p className="text-xs text-slate-600 mt-1">{dommage.objet}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-xs text-slate-500">
                            {new Date(dommage.date_declaration).toLocaleDateString('fr-FR')}
                          </p>
                          <Button size="sm" variant="ghost" className="mt-2">
                            <Eye className="h-4 w-4" />
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* Mes Dommages */}
        <ExpertDommagesTab ctx={ctx} />

        {/* Messagerie */}
        {activeTab === 'messagerie' && (
          <MessagerieDashboard />
        )}

        {/* GED Universelle */}
        {activeTab === 'ged-universelle' && (
          <GEDUniverselle />
        )}

        {/* GED DOMIUM */}
        {activeTab === 'ged-domium' && (
          <GEDDomium />
        )}

        {/* Mes Conventions */}
        {activeTab === 'conventions' && (
          <MesConventions userType="expert" />
        )}

        {/* Signature / Tampon */}
        {activeTab === 'signature' && (
          <ModuleSignatureExpert 
            getAuthHeader={getAuthHeader} 
            expert={expertProfile || user}
          />
        )}

        {/* Modèles Documents */}
        {activeTab === 'modeles' && (
          <GestionModeles 
            getAuthHeader={getAuthHeader} 
            userRole="expert"
          />
        )}

        {/* Vidéos */}
        {activeTab === 'videos' && (
          <VideoManager userRole="expert" showUpload={true} showDelete={true} />
        )}

        {/* Mon Profil */}
        {activeTab === 'profil' && expertProfile && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Mon Profil Conseiller</h2>
            <ExpertProfileEdit 
              expert={expertProfile} 
              onUpdate={(updated) => setExpertProfile(updated)} 
              getAuthHeader={() => ({ Authorization: `Bearer ${getToken()}` })} 
            />
          </div>
        )}

        {/* Paramètres */}
        {activeTab === 'parametres' && (
          <div className="space-y-6">
            <h1 className="text-3xl font-bold text-slate-900">Paramètres</h1>

            <Card>
              <CardHeader>
                <CardTitle>Modifier mes informations</CardTitle>
                <CardDescription>
                  Mettez à jour vos informations professionnelles
                </CardDescription>
              </CardHeader>
              <CardContent>
                {expertProfile && (
                  <ExpertProfileEdit 
                    expert={expertProfile} 
                    onUpdate={(updated) => setExpertProfile(updated)} 
                    getAuthHeader={() => ({ Authorization: `Bearer ${getToken()}` })} 
                  />
                )}
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Shield className="h-5 w-5 text-blue-600" />
                  Sécurité du compte
                </CardTitle>
                <CardDescription>
                  Gérez la sécurité de votre compte
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ChangePasswordForm 
                  getAuthHeader={() => ({ Authorization: `Bearer ${getToken()}` })} 
                />
              </CardContent>
            </Card>
          </div>
        )}
    </>
  );
}
